import { GetListResult } from "react-admin"
import HttpClient from "../HttpClient"
import ConstructSequelizeFilters from "../utils/ConstructSequelizeFilters"
import axios from "axios"

export class CuisineDishService {
    async getAllDishes(limit: number, offset: number, filters: {}, sort: {}): Promise<GetListResult<any>> {
        filters = ConstructSequelizeFilters(filters, ['name'], ['mealType', 'type', 'dishType', 'categoryId']);
        let data = await HttpClient.get('/cuisine/dishes', {
            params: {
                limit,
                offset,
                filters,
                sort
            }
        })
        return {
            data: data.data.data,
            total: data.data.count
        }
    }

    async getDishById(dishId: number): Promise<any> {
        const data = await HttpClient.get(`/centaurus/cuisine/categories/dishes/${dishId}`)
        return data
    }

    async updateDishData(dishId: number, paylaod: any): Promise<any> {
        const data = await HttpClient.patch(`/centaurus/cuisine/categories/dishes/${dishId}/update-dish`, paylaod);
        return data?.data
    }

    async getAWSLinks(imageName: string) {
        let payload = {
          directory: "dishes",
          fileName: imageName,
        };
        const data = await HttpClient.get("uploadImage/getSignedUrl", {
          params: payload,
        });
        return data?.data;
    }

    async uploadImageToAWS(url: string, binaryImage: File | Blob) {
        console.log("Uploading to URL:", url);
        console.log("File Type:", binaryImage?.type);
        try {
          const response = await axios.put(url, binaryImage);
          console.log("Upload success:", response.status);
          return response;
        } catch (err: any) {
          console.error("Upload failed:", err?.response?.status, err?.response?.data);
          throw err;
        }
    }

    async getDishCategories(): Promise<any> {
        const data = await HttpClient.get('/cuisine/categories')
        return data.data
    }

    async getCategoryTags(): Promise<any> {
        const data = await HttpClient.get('/cuisine/dish-category-tags')
        return data.data
    }

    async getDishInstructionCategories(): Promise<any> {
        const data = await HttpClient.get('/centaurus/cuisine/categories/dish-instruction-categories');
        return data.data;
    }

    async getDishEquipments(): Promise<any> {
        const data = await HttpClient.get('/centaurus/cuisine/categories/dish-equipments');
        return data.data;
    }

    async createCuisineDish(payload: any): Promise<any> {
        const data = await HttpClient.post('/centaurus/cuisine/categories/dishes/add-dish', payload);
        return data.data;
    }

    async updateDish(dishId: number, payload: any): Promise<any> {
        const data = await HttpClient.patch(`/centaurus/cuisine/categories/dishes/${dishId}/update-dish`, payload);
        return data.data;
    }

    async deleteDish(dishId: number): Promise<any> {
        const data = await HttpClient.delete(`/centaurus/cuisine/categories/dishes/${dishId}`);
        return data.data;
    }

    async getDishIngredients(dishId: number): Promise<any> {
        const data = await HttpClient.get(`/cuisine/categories/dishes/${dishId}/ingredients`)
        return data
    }

    async addDishIngredientById(dishId: number, payload: any): Promise<any> {
        const data = await HttpClient.post(`/cuisine/categories/dishes/${dishId}/ingredients/add-ingredient`, payload)
        return data
    }

    async updateDishIngredient(cuisineDishIngredientId: number, payload: any): Promise<any> {
        const data = await HttpClient.patch(`/cuisine/categories/dishes/ingredients/update-ingredient/${cuisineDishIngredientId}`, payload)
        return data
    }

    async deleteDishIngredientById(cuisineDishIngredientId: number): Promise<any> {
        const data = await HttpClient.delete(`/cuisine/categories/dishes/ingredients/remove-ingredient/${cuisineDishIngredientId}`)
        return data
    }
}
